import resetCalendar from "./resetCalendar.js";
import handlerInput from "./handlerInput.js";
import clickCalendar from "./clickCalendar.js";
import createCalendarToInput from "./createCalendarToInput.js";
const initCalendar = (self) => {
  if (!self.HTMLElement)
    return;
  createCalendarToInput(self);
  resetCalendar(self);
  handlerInput(self);
  clickCalendar(self);
};
export {
  initCalendar as default
};
